const shaka = require('external/shaka-player.ui.debug');

const HideControlsOverlay = class extends shaka.ui.Element {
  constructor(parent: typeof HideControlsOverlay, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('div') as HTMLDivElement;
    this.button_.classList.add('shaka-hide-controls-overlay');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'click', () => {
      controls.controlsContainer_.removeAttribute('shown');
    });
  }
};

// Factory that will create a button at run time.
HideControlsOverlay.Factory = class {
  create(rootElement, controls) {
    return new HideControlsOverlay(rootElement, controls);
  }
};

export default HideControlsOverlay;
